import {CHECK_IS_SIDEBAR_COLLAPSE} from "../constants/index";

const initialState = {
    is_collapsed : ''
}

const sidebar = (state = initialState, action) => {
    const {payload, type} = action
    switch (type) {
        case CHECK_IS_SIDEBAR_COLLAPSE: {
            return {
                ...state,
                is_collapsed: payload
            }
        }
    
        default:
            return state;
    }
}

export default sidebar